import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';

export default function TenantPermissionRoute({ permission, children }) {
  const location = useLocation();
  const { user, logout } = useAuth();
  const permissions = user?.role === 'admin'
    ? ['dashboard', 'bookings', 'settings', 'tablet', 'users']
    : (user?.permissions || []);

  if (permissions.includes(permission)) {
    return children;
  }

  const routeByPermission = [
    ['dashboard', '/admin/dashboard'],
    ['bookings', '/admin/bookings'],
    ['settings', '/admin/settings'],
    ['tablet', '/tablet'],
  ];
  const fallbackPath = routeByPermission.find(([key]) => permissions.includes(key))?.[1] || null;

  if (fallbackPath && fallbackPath !== location.pathname) {
    return <Navigate to={fallbackPath} replace />;
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="max-w-md rounded-xl border bg-background p-6 text-center space-y-3">
        <h2 className="font-heading text-xl">No access assigned</h2>
        <p className="text-sm text-muted-foreground">
          This user does not currently have permission to open any admin area.
          Ask an admin to update permissions for this PIN user.
        </p>
        <Button onClick={logout}>Sign out</Button>
      </div>
    </div>
  );
}
